import { TestResultProps } from './types';

export const TestsResult = ({ message, errorsCount, data }: TestResultProps) => {
  return (
    <div>
      <h1>Tests Result</h1>
      {message && <p>{message}</p>}
      {errorsCount ? <p>Errors Count: {errorsCount}</p> : <h3>No Data...</h3>}
      {data &&
        data?.map((item) => (
          <div key={item?.endpoint}>
            <h2>Endpoint:{item?.endpoint}</h2>
            <p>
              <strong>Test Case:</strong> {item?.testCase}
            </p>
            <p>
              <strong>Errors:</strong> {item.errors?.map((error) => error.err).join(', ')}
            </p>
          </div>
        ))}
    </div>
  );
};
